










































import { Component, Prop, Watch } from 'vue-property-decorator';

import SignUpService from '@/api/SingupService';

import { updateRegistration } from '@/utils/updateRegistration';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';

import { ConfigFormData } from '@/models/onboarding';
import {
  StartGuideTask,
  EStartGuideTaskSlug,
  StartGuideCardActiveProgram
} from '@/models/start-guide';
import { handleCompleteTask } from '@/utils/start-guide';

import { validation as formValidate } from '@/views/Onboarding/Steps/Refund/validation';
import { configFormDataFactory } from '@/views/Onboarding/helpers';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import RefundConfigForm from '@/components/organisms/RefundConfigForm/RefundConfigForm.vue';

import RewardsProgramCommon from '../RewardsProgramCommon.vue';
import { OPERATION_TYPE_STORAGE_KEY } from './Operation.vue';
import BusinessService from '@/api/BusinessService';
import SellCoinsService from '@/api/SellCoinsService';
import { ETutorial } from '@/models/tutorial';
import flagKeys from '@/constants/flagKeys';
import { IBusinessType } from '@/models/business';
import {
  EAutomaticCampaignName,
  EIncentiveType,
  ESellCoinsCampaignStatus
} from '@/models/sell-coins';
import { EProgramStatusStatus } from '@/models/program-status';

@Component({
  components: {
    RefundConfigForm,
    FilledButton
  }
})
export default class RefundPolicy extends RewardsProgramCommon {
  @Prop() task!: StartGuideTask;

  signUpService = new SignUpService();
  businessService = new BusinessService();
  sellCoinsService = new SellCoinsService();

  formData: ConfigFormData = this.formDataStore || configFormDataFactory();
  loading = false;

  get isValidForm() {
    return formValidate(this.formData);
  }

  get formDataStore() {
    const { refundPolicy = undefined } = this.rewardsProgramFormData;

    return refundPolicy;
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get ctaText() {
    if (this.$mobileCheck()) return 'Launch';

    return 'Launch Rewards';
  }

  get activePrograms() {
    return this.$store.getters[
      'startGuide/getActivePrograms'
    ] as StartGuideCardActiveProgram[];
  }

  get rewardsProgramStatus() {
    const rewardCoinsProgram = this.activePrograms.find(
      program => program.slug === 'reward-coins'
    );

    if (!rewardCoinsProgram) return '';

    return rewardCoinsProgram.label || '';
  }

  @Watch('rewardsProgramStatus')
  onRewardsProgramStatusChange(state: string) {
    if (state) {
      this.$emit('goToStep', {
        redirectToSlug: this.ERewardsProgramStepSlug.FEEDBACK_STATUS
      });
      this.loading = false;
    }
  }

  handleChangeRefundConfig(formData: ConfigFormData) {
    this.formData = formData;

    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      refundPolicy: formData
    });
  }

  async onSubmit() {
    if (!this.isValidForm) {
      this.$notification('Please select an option', 'error');

      return;
    }

    const { customValue, value } = this.formData;

    const refundPolicyPayload = { refundsLimitDays: value || customValue };
    const rewardRatioPayload =
      this.rewardsProgramFormData.rewardRatioPayload || {};

    const payload: any = {
      ...rewardRatioPayload,
      ...refundPolicyPayload
    };
    const operationType =
      this.rewardsProgramFormData.operationType ||
      localStorage.getItem(OPERATION_TYPE_STORAGE_KEY);

    if (
      operationType &&
      this.businessInfo.type === this.businessInfo.operationType
    )
      payload.operationType = operationType;

    this.loading = true;

    try {
      const { data } = await this.signUpService.setupRules(payload);

      await Promise.all([
        updateRegistration('manage-rewards'),
        updateRegistration('return-policy')
      ]);

      localStorage.removeItem(OPERATION_TYPE_STORAGE_KEY);

      if (
        !this.businessInfo.seenInStoreOnlineRewardWhatsNew &&
        this.$store.getters['flags/getFlags'].includes(
          flagKeys.addWixMultipleIntegration
        )
      ) {
        await this.businessService.updateBusinessFlagTutorial({
          state: true,
          flag: ETutorial.SEEN_INSTORE_ONLINE_REWARD
        });
      }

      if (
        this.rewardsProgramFormData.rewardRatioPayload &&
        this.$store.getters['flags/getFlags'].includes(
          flagKeys.dashboardSellCoinsAndLoyaltVerify
        )
      ) {
        const sellCoinsAction = this.rewardsProgramFormData.rewardRatioPayload
          .sellCoinsAction;

        if (sellCoinsAction === 'createNewCampaign' || !sellCoinsAction) {
          await this.sellCoinsService.deactivateActiveCampaign();

          const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
          let newCampaignStatus = ESellCoinsCampaignStatus.INACTIVE;
          if (listOfCampaigns.data.items.length) {
            newCampaignStatus = ESellCoinsCampaignStatus.ACTIVE;
          }

          await this.sellCoinsService.createSellingCoinsCampaign({
            name: EAutomaticCampaignName.loyalt,
            incentiveValue: this.rewardsProgramFormData.rewardRatioPayload
              .coinRewardPercentage,
            incentiveType: EIncentiveType.BONUS,
            automaticallyCreated: true,
            status: newCampaignStatus
          });
        } else if (sellCoinsAction === 'disableSellCoins') {
          const response = await this.businessService.updateSellCoins(
            !this.businessInfo.sellCoins,
            DashboardScreen.Loyalt
          );

          this.$store.dispatch('business/SET_BUSINESS_INFO', {
            ...this.businessInfo,
            sellCoins: response.data.sellCoins
          });
        }
      }

      const { startBy } = this.$store.getters['startGuide/getPreferences'];
      if (startBy) {
        this.$store.dispatch('startGuide/SET_PREFERENCES', {
          startBy: undefined
        });
        this.$store.dispatch('startGuide/UPDATE_PREFERENCES');
      }

      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        refundsLimitDays: data.refundsLimitDays,
        coinRewardPercentage: data.coinRewardPercentage,
        coinPurchaseRatio: data.coinPurchaseRatio,
        operationType: payload.operationType || this.businessInfo.type,
        seenInStoreOnlineRewardWhatsNew: true
      });

      if (
        this.businessInfo.type === IBusinessType.INSTORE &&
        this.$store.getters['flags/getFlags'].includes(
          flagKeys.dashboardSellCoinsAndLoyaltVerify
        )
      ) {
        this.$store.dispatch('business/SET_REWARD_STATUS', {
          ...this.$store.getters['business/getRewardStatus'],
          operationStatus: EProgramStatusStatus.ACTIVE,
          rewardStatus: EProgramStatusStatus.PARTIALLY_ACTIVE
        });
      }

      handleCompleteTask(EStartGuideTaskSlug.REWARD_COINS);

      this.$store.dispatch('rewardsProgram/RESET_FORM_DATA');

      this.$store.dispatch(
        'startGuide/FILTER_TASKS_BY_OPERATION',
        payload.operationType || this.businessInfo.type
      );

      if (this.rewardsProgramStatus) {
        this.loading = false;
        this.$emit('goToStep', {
          redirectToSlug: this.ERewardsProgramStepSlug.FEEDBACK_STATUS
        });
      }
    } catch {
      this.loading = false;
    }
  }
}
